function SectionRule({
  index,
  jaLabel,
  enLabel,
  note,
}: {
  index: string;
  jaLabel: string;
  enLabel: string;
  note: string;
}) {
  return (
    <div className="section-rule">
      <span className="section-rule__index">{index}</span>
      <span className="section-rule__ja">{jaLabel}</span>
      <span className="section-rule__en">{enLabel}</span>
      <span className="section-rule__line" aria-hidden="true" />
      <span className="section-rule__note">{note}</span>
    </div>
  );
}

function CreditModal({ credit, onClose }: { credit: string; onClose: () => void }) {
  return (
    <div className="table-modal" role="presentation">
      <button className="table-modal__scrim" type="button" aria-label="このサービスについて" onClick={onClose} />
      <section
        className="table-modal__panel credit-modal__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="estat-credit-title"
      >
        <div className="table-modal__header">
          <h4 id="estat-credit-title">このサービスについて</h4>
          <button className="modal-close-button" type="button" onClick={onClose}>
            閉じる
          </button>
        </div>
        <div className="credit-modal__body">
          {/* creditは改行(\n)区切りの複数段落(pipeline/registry.py の E_STAT_CREDIT) */}
          {credit.split("\n").map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </div>
      </section>
    </div>
  );
}

function InfoTooltip({ label, text }: { label: string; text: string }) {
  return (
    <span className="info" tabIndex={0} aria-label={`${label}: ${text}`}>
      i
      <span className="bub" role="tooltip">
        {text}
      </span>
    </span>
  );
}

export { SectionRule, InfoTooltip, CreditModal };
